<template>
    <TStandardGuide />
</template>

<script>
import TStandardGuide from '../../../templates/terminal/t-standard-guide';

import {
    START_VIEW_API,
    STOP_VIEW_API
} from "@/shared/components/map-viewer/constants/map-events";
import { EventBus } from "@/plugins/eventbus";
import { 
    START_SCREEN,
    TERMINAL_STANDARD_GUIDE
} from "@/utils/constants/pages";
import { GO_BACK_VIEW } from "@/utils/constants/bus-events-constants";

export default {
    name: "PStandardGuide",
    data() {
        return {
            prevRoute: null
        }
    },
    components: {
        TStandardGuide
    },
    mounted() {
        this.initListeners();
    },
    beforeDestroy() {
        this.removeListeners();
    },
    methods: {
        initListeners() {
            this.$bus.$on(`${GO_BACK_VIEW}-${TERMINAL_STANDARD_GUIDE}`, this.handleGoBackRoute);
        },
        removeListeners() {
            this.$bus.$off(`${GO_BACK_VIEW}-${TERMINAL_STANDARD_GUIDE}`, this.handleGoBackRoute);
        },
        handleGoBackRoute() {
            const params = this.prevRoute.name ? { ...this.prevRoute } : { name: START_SCREEN };

            this.$router.push(params)
        }
    },
    beforeRouteLeave(to, from, next) {
        if (!to.name.includes("guide"))
            this.$bus.$emit(STOP_VIEW_API);
        next();
    },
    beforeRouteEnter(to, from, next) {
        if (to.name.includes("guide")){
            // EventBus.$bus.$emit(START_VIEW_API);
        }
        next(vm => {
            vm.prevRoute = from;
        });
    },
}
</script>
